// set state actions
export const SETSTEP = "SETSTEP";

export const SETCOURSEID = "SETCOURSEID";
export const SET_REFERCODE = "SET_REFERCODE";
export const SETHASNOTIF = "SETHASNOTIF";
export const SETGIFTCODE = "SETGIFTCODE";
export const SETWEEKDAYS = "SETWEEKDAYS";
export const SETISTEMP = "SETISTEMP";
export const SETCLASSROOMID = "SETCLASSROOMID";
export const SETUSESYSTEMSEARCH = "SETUSESYSTEMSEARCH";
export const SETGENDER = "SETGENDER";
export const SETMINAGE = "SETMINAGE";
export const SETMAXAGE = "SETMAXAGE";
export const SETINVITECODE = "SETINVITECODE";
export const SETINVITECODEBOX = "SETINVITECODEBOX";
export const SETSTARTDATE = "SETSTARTDATE";
export const ISWITHTEACHER = "ISWITHTEACHER";
